import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
const MobileBottomMenu = () => {
    const container = useSelector((state) => state);
    const [isOpen, setIsOpen] = useState(false);
    const sheetRef = useRef(null);
    const { contextSafe } = useGSAP({ scope: sheetRef });
    // تفعيل الأنميشن بشكل آمن عند الضغط
    const toggleMenu = contextSafe(() => {
        if (!isOpen) {
            // فتح القائمة بتأثير ارتدادي (Elastic) مطاطي فخم
            gsap.to(sheetRef.current, {
                y: 0,
                borderRadius: "32px 32px 0px 0px",
                duration: 0.75,
                ease: "elastic.out(1, 0.65)" // سر الحركة المطاطية السائلة
            });
            // تتابع ظهور عناصر القائمة
            gsap.fromTo(".menu-item", 
                { opacity: 0, y: 20 }, 
                { opacity: 1, y: 0, stagger: .2, delay: 0.2 }
            );
        } else {
            // إغلاق القائمة بسحبها لأسفل الشاشة بسلاسة
            gsap.to(sheetRef.current, {
                y: "100%",
                duration: 0.4,
                ease: "power3.in"
            });
        }
        setIsOpen(!isOpen);
    });
    return (
    container.MenuPH.menu === "true" ? 
            (<div id="elastMenu" style={{ position: 'relative', background: '#0b0c10', overflow: 'hidden', zIndex:100000 }}>   
                <button onClick={toggleMenu} style={fabStyle}>
                    {isOpen ? "✕" : "☰ القائمه"}
                </button>
                <div ref={sheetRef} style={sheetStyle}>
                    <div style={{ width: '40px', height: '5px', background: '#4b5563', borderRadius: '10px', margin: '0 auto 30px auto' }} />
                    <nav style={{ display: 'flex', flexDirection: 'column', gap: '20px', direction: 'rtl' }}>
                        <a href="/" className="menu-item" style={itemStyle}>🏠 الرئيسية</a>
                        <a href="#services" className="menu-item" style={itemStyle}>💼 خدماتنا البرمجية</a>
                        <a href="#revs" className="menu-item" style={itemStyle}>🚀 تقييمات SASKE</a>
                        <a href="#contact" className="menu-item" style={itemStyle}>📞 تواصل معنا</a>
                    </nav>
                </div>
            </div>)
        : " "
    
    );
};

// التنسيقات المصممة للموبايل
const fabStyle = {
    position: 'fixed', bottom: '30px', left: '50%', transform: 'translateX(-50%)',
    background: 'linear-gradient(135deg, #6366f1, #a855f7)', color: 'white',
    padding: '16px 32px', borderRadius: '30px', border: 'none', fontWeight: 'bold',
    boxShadow: '0 10px 25px rgba(168, 85, 247, 0.4)', zIndex: 1000
};

const sheetStyle = {
    position: 'fixed', bottom: 0, left: 0, width: '100%', height: '40vh',
    background: '#11131e', borderTop: '2px solid #312e81', padding: '20px',
    transform: 'translateY(100%)', // تبدأ مخفية تحت الشاشة
    borderRadius: '100px 100px 0px 0px', // تبدأ دائرية جداً لتعطي تأثير سائل أثناء الصعود
    zIndex: 999,
    willChange: 'transform'
};

const itemStyle = {
    color: 'white', fontSize: '1.4rem', fontWeight: 'bold', padding: '15px 10px',
    borderBottom: '1px solid rgba(255,255,255,0.05)'
};


export default MobileBottomMenu;